export const YES = 'yes';
export const NO = 'no';
export const NIF = 'NIF';
export const NIE = 'NIE';
export const PASSPORT = 'Pasaporte';
export const DNI_OHTERS = 'DNI Otros países';
export const MESSAGE_MODAL = '.MESSAGE';
export const TITLE_MODAL = '.TITLE';

export const USER_IDENTIFICATION_RETRIES = 3;
export const TIMEOUT_TIME_MS = 120000;
export const USER_PIN_VALIDATION_RETRIES = 3;
export const LABEL_USER_IDENTIFICATION_RETRIES = 'USER_IDENTIFICATION_RETRIES';
export const CENTRAL_TIMEZONE = 'Europe/Madrid';
export const TIMEOUT_ERROR = 'TimeoutError';
export const PHONE_NUMBERS = 'PHONE_NUMBERS';
export const PAYMENT_ASSISTANT_PHONE_NUMBERS_LIST = 'receiptPaymentAssistancePhoneNumbersList';
export const RECEIPT_PAYMENT_DEPARTMENT_DATA ='RECEIPT_PAYMENT_DEPARTMENT_DATA';
export const RECEIPT_PAYMENT_COMPANY_DEPARTMENT_DATA = 'RECEIPT_PAYMENT_COMPANY_DEPARTMENT_DATA';
export const RECEIPT_DESCRIP_GENERIC = 'MAPFRE Seguros {{policyNumber}}';

export const DATE_FORMAT_YYYY_MM_DD = 'YYYY-MM-DD';
export const DATE_FORMAT_DDMMYYYY = 'DD/MM/YYYY';
export const LABEL_TRUE = 'true';

// Service Params
export const RO_ENTITY_CODE = 'roEntityCode';
export const RO_GROUPING_CODE = 'roGroupingCode';
export const RO_ORIGIN = 'roOrigin';
export const RO_PRODUCT_CODE = 'roProductCode';
export const RO_PRODUCT_ID = 'roProductId';
export const RO_OPERATION_CODE_PREFIX = 'roOperationCodePrefix';
export const RO_DOCUMENT_NUMBER = 'oDocumentNumber';
export const DEFAULT = 'Default';
export const LANGUAGE = {
  default: 'Default',
  android: 'android'
} as const;
export const SMS = 'SMS';
export const RECEIPT_PAYMENT_LABEL = 'RECEIPT_PAYMENT';
export const APP_IDS_PRIVATE = 'APP_IDS_PRIVATE';
export const APP_IDS_COMPANY = 'APP_IDS_COMPANY';
export const AMAZON_PAY_APP = 'amazonPayAppId';
export const AMAZON_PAY_ORIGIN = 'amazonPayOrigin';

//// Routes
export const RECEIPT_PAYMENT_ROUTE = 'receipt-payment';
export const DETAIL_ROUTE = '/detail';
export const LIST_ROUTE = '/list';
export const RESULT_SUCCESS_ROUTE = '/result-success';
export const RESULT_KO_ROUTE = '/result-ko';
export const VALIDATE_CODE_ROUTE = '/validate-code';

export const ERROR_RECEIPT_NUMBER = 'El número de recibo no es válido';
export const GENERIC_ERROR = 'Error';

export const PHONE_NUMBERS_SEPARATOR = ' / ';
